import React from "react";
import PageHeader from "../../componentsII/PageHeader"
import { CheckCircle2, BarChart3, Upload, X, PenBoxIcon ,ExternalLink,Download} from "lucide-react";
import { useState } from "react";
import AddEditSources from "../../components/scope3/AddEditSources";
import { Modal, Box } from "@mui/material";
import { useEffect } from "react";
import api from "../../axios/api";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Scope3 = () => {
  const [isAddSourcesModalOpen, setIsAddSourcesModalOpen] = useState(false);
  const [inReviewSources, setInReviewSources] = useState([]);
  const [doneSources, setDoneSources] = useState([]);
  const [sources, setSources] = useState([]);
  const [totalEmission, setTotalEmission] = useState(0);
  const navigate = useNavigate();
  const selectedYear = useSelector((state) => state.user.selectedYear);

  const user = useSelector((state) => state.user.user);

  const getSelectedSources = async () => {
    try {
      const res = await api.get(`/company/getScope3Selection?company_id=${user.company.id}&comp_data_year_id=${selectedYear.id}`);
      const data = res.data.data;

      const doneSources = data.filter(item => item.review_done === 1);
      const inReviewSources = data.filter(item => item.send_for_review === 1 && item.review_done !== 1);
      const sources = data.filter(item => item.review_done === 0 && item.send_for_review === 0);

      setDoneSources(doneSources);
      setInReviewSources(inReviewSources);
      setSources(sources);

      // ✅ Calculate total emission from only doneSources
      const totalEmission = doneSources.reduce((sum, item) => {
        const emission = parseFloat(item.co2_emission_tonnes);
        return sum + (isNaN(emission) ? 0 : emission);
      }, 0);

      setTotalEmission(totalEmission);

    } catch (error) {
      console.error("Error fetching sources:", error);
    }
  };

  const handleModalClose = async () => {
    setIsAddSourcesModalOpen(false);
    await getSelectedSources(); // Refresh the sources list
  };

  useEffect(() => {
    getSelectedSources();
  }, []);

  const SourceCard = ({ source, type = 'upload' }) => {
    const [modalData, setModalData] = useState({});

    const handleUploadClick = async (source) => {
      const formattedCategory = source.categories.cat_no
        .trim()  // Remove any leading or trailing spaces
        .replace(/\s+/g, '') // Remove all spaces
        .toLowerCase(); // Convert to lowercase
      navigate(`/add-edit-source-data/${formattedCategory}`);
      setModalData(source);
    };

    const download = async (source) => {
      if (source?.review_file_path) {
        const link = document.createElement("a");
        link.href = source.review_file_path;
        link.download = source.review_file_path.split('/').pop(); // filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.warn("No file path available for download");
      }
    };
    
    return (
      <div className="border-2 border-gray-300 rounded-lg mb-2">
        <div className="flex justify-between items-start p-4">
          <div className="flex flex-col">
            <p className="text-md font-semibold">{source.categories.cat_title}</p>
            <p className="text-sm text-gray-500">{source.categories.cat_no}</p>
          </div>
        </div>
        <hr />
        {(type === 'upload') && (
          <div className="px-4 py-2 flex justify-end">
            <button
              className="px-4 py-2 text-white rounded-md hover:bg-blue-600"
              style={{ background: '#15803d' }}
              onClick={() => handleUploadClick(source)}
              title={`${source?.file_name ? 'Edit' : 'Add'} ${source.categories.cat_title}`}
            >
              {source?.file_name ? 'Edit' : ' + Add'} Data
            </button>
          </div>
        )}
        {(type === 'review') && (
          <div className="px-4 py-2 flex justify-between items-center">
            <div className="text-sm">Data Being Reviewed</div>
            <button
              className="p-2 text-black border border-gray-800 rounded-md bg-gray-100 hover:bg-gray-300 flex gap-1 items-center"
              onClick={() => handleUploadClick(source)}
              title={`View ${source.categories.cat_title}`}
            >
           <ExternalLink size={16} title="Edit" color="black" />
            </button>
          </div>
        )}
        {(type === 'reviewed') && (
          <div className="px-4 py-2 flex justify-between items-center">
            <div className="text-sm">Data Reviewed</div>
          <div className="flex gap-2 items-center">
          <button
           className="p-2 text-white border border-gray-800 rounded-md bg-gray-100 hover:bg-gray-300 flex gap-1 items-center"
           onClick={() => download(source)}
           title={`Download Review File`}
         >
           <Download size={16} title="Download" color="black" />
         </button>
          <button
           className="p-2 text-white border border-gray-800 rounded-md bg-gray-100 hover:bg-gray-300 flex gap-1 items-center"
           onClick={() => handleUploadClick(source)}
           title={`View ${source.categories.cat_title}`}
         >
           <ExternalLink size={16} title="View" color="black" />
         </button>
            <div className="px-2 py-1 border rounded-full text-sm bg-green-100">{source.co2_emission_tonnes} tCO₂e</div>
          </div>
          </div>
        )}
      </div>
    )
  };



  const PanelHeader = ({ title, count, bgColor = "bg-gray-100",title2 }) => (
    <div className="flex justify-between items-center mb-4">
      <div className="flex gap-2"><h2 className="text-lg font-semibold">{title}</h2>{title2 ? <div className={`${bgColor} mt-1 px-2 py-1 rounded-full text-sm`}>{title2}</div> : <></>}</div>
      <span className={`${bgColor} px-2 py-1 rounded-full text-sm`}>{count}</span>
    </div>
  );

  return (
    <div>
      <PageHeader title="Scope 3" buttonTitle="" handleClick={() => { }}>
        {/* <div className="p-2 flex justify-end"> {doneSources.length}/{sources.length + inReviewSources.length + doneSources.length}complete</div> */}

        <div className="flex gap-2 p-2 w-full">
          {/* Upload Data Panel */}
          <div className="flex-1 bg-white rounded-lg p-4 border h-[600px] shadow-sm flex flex-col">
            <PanelHeader title="Upload Data" count={sources.length} />
            <hr className="border-gray-500 mb-4" />

            <div className="flex-1 overflow-y-auto">
              {sources.length === 0 ? (
                <div className="flex flex-col items-center justify-center h-full">
                  <Upload className="w-12 h-12 text-gray-400 mb-4" />
                  <p className="text-sm text-gray-500">No tracked sources added yet</p>
                </div>
              ) : (
                <div>
                  {sources.map((source, index) => (
                    <SourceCard key={index} source={source} />
                  ))}
                </div>
              )}
            </div>

            <button
              className="mt-4 w-full py-2 px-4 bg-white border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50"
              onClick={() => setIsAddSourcesModalOpen(true)}
              title={sources.length === 0 ? '+ Add Sources' : 'Edit Sources'}
            >
              {sources.length === 0 ? '+ Add Sources' : 'Edit Sources'}
            </button>
          </div>

          {/* In Review Panel */}
          <div className="flex-1 rounded-lg p-4 border h-[600px] shadow-sm flex flex-col" style={{ backgroundColor: '#F0F7FD' }}>
            <PanelHeader
              title="Upload & In Review"
              count={inReviewSources.length}
              bgColor="bg-blue-100"
            />
            <hr className="border-gray-500 mb-4" />

            <div className="flex-1 overflow-y-auto">
              {inReviewSources.length === 0 ? (
                <div className="flex flex-col items-center justify-center h-full">
                  <BarChart3 className="w-12 h-12 text-blue-400 mb-4" />
                  <p className="text-sm text-gray-600 text-center">
                    After uploading data, your climate professional will calculate your footprint.
                  </p>
                </div>
              ) : (
                <div className="space-y-2">
                  {inReviewSources.map((source, index) => (
                    <SourceCard key={index} source={source} type="review" />
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Done Panel */}
          <div className="flex-1 rounded-lg p-4 border h-[600px] shadow-sm flex flex-col bg-green-50">
            <PanelHeader
              title="Done"
              count={`${doneSources.length}`}
              bgColor="bg-green-100"
              title2={`${totalEmission} tCO₂e`}
            />
            <hr className="border-gray-500 mb-4" />

            <div className="flex-1 overflow-y-auto">
              {doneSources.length === 0 ? (
                <div className="flex flex-col items-center justify-center h-full">
                  <CheckCircle2 className="w-12 h-12 text-green-400 mb-4" />
                  <p className="text-sm text-gray-600 text-center">
                    After calculation, your data and total tCO₂e will appear here.
                  </p>
                </div>
              ) : (
                <div className="space-y-2">
                  {doneSources.map((source, index) => (
                    <SourceCard key={index} source={source} type="reviewed" />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <Modal
          open={isAddSourcesModalOpen}
          onClose={() => setIsAddSourcesModalOpen(false)}
          aria-labelledby="add-location-modal-title"
          aria-describedby="add-location-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: "8px",
              display: "relative",
            }}
          >
            <button
              onClick={() => setIsAddSourcesModalOpen(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
              aria-label="Close"
            >
              <X size={24} />
            </button>
            <AddEditSources
              mode={sources.length === 0 ? "add" : "edit"}
              open={isAddSourcesModalOpen}
              handleClose={handleModalClose}
            />
          </Box>
        </Modal>
      </PageHeader>
    </div>
  );
};

export default Scope3;